import styled from "styled-components";

export const UpdatesSocial = styled.div`
	flex: 1;
	margin-right: 1rem;
`;

export const SocialCheckboxes = styled.div`
	display: flex;
	gap: 2rem;
	margin-bottom: 1rem;
`;
